import { useCallback, useSyncExternalStore } from 'react';
import { PASS_CHANGE_EVENT, PASS_STORAGE_KEY, forgetPass, loadPass, savePass } from '../lib/relayApi';

const subscribe = (onChange: () => void) => {
  const onStorage = (event: StorageEvent) => {
    // null: another tab cleared all storage.
    if (event.key === PASS_STORAGE_KEY || event.key === null) onChange();
  };
  // Belt and braces for browsers that miss a storage event: look again when the tab comes back.
  const onVisible = () => {
    if (document.visibilityState === 'visible') onChange();
  };
  window.addEventListener('storage', onStorage);
  window.addEventListener(PASS_CHANGE_EVENT, onChange);
  document.addEventListener('visibilitychange', onVisible);
  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(PASS_CHANGE_EVENT, onChange);
    document.removeEventListener('visibilitychange', onVisible);
  };
};

/**
 * The relay pass saved in this browser, kept in step everywhere it shows:
 * the header, the file form, and other tabs (a pass bought in its own tab
 * appears in the form that sent the buyer there).
 */
export function usePass(): [string | null, (next: string | null) => void] {
  const pass = useSyncExternalStore(subscribe, loadPass, () => null);
  const setPass = useCallback((next: string | null) => (next ? savePass(next) : forgetPass()), []);
  return [pass, setPass];
}
